export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/nineDaysWarranty.6794ad89.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};